module.exports = __webpack_public_path__ + "img/1f992.49b17aa.svg";